import { passwordComplexityRegex } from "../../../common/constants/regex";
import * as Yup from 'yup';

export interface ChangePasswordDto {
  currentPassword: string,
  password: string,
  confirmPassword: string,
}

export const changePasswordInit: ChangePasswordDto = { currentPassword: '', password: '', confirmPassword: '' };

export const changePasswordValidationSchema = Yup.object({
  currentPassword: Yup.string()
    .min(8, 'Password must be 8 characters or longer.')
    .required('Please enter your current password.'),
  password: Yup.string()
    .required('Please enter your new password.')
    .min(12, 'Password must be 12 characters or longer.')
    .max(128, 'New password must be 128 characters or less.')
    .matches(
      passwordComplexityRegex,
      'Password must contain at least 1 uppercase character, 1 lowercase character, 1 number, 1 special character and be at least 12 characters.'
    ),
  confirmPassword: Yup.string()
    .oneOf(
      [Yup.ref('password')],
      'New password and confirm password must match.'
    )
    .required('Please re-enter your new password.'),
})